import type { ReactNode } from "react";
import { useMatch, useParams } from "react-router-dom";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import type { PageId } from "@/components/common/types";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import { NotFound } from "@/pages/NotFound";
import useAuth from "@/services/useAuth";

import LorebookCreate from "./LorebookCreate";
import LorebookDetail from "./LorebookDetail";
import LorebookEdit from "./LorebookEdit";

export default function Lorebook() {
  const { id, lang } = useParams();
  const basePath = lang ? `/${lang}` : "";
  const matchCreate = useMatch(`${basePath}/lorebook/create`);
  const matchEdit = useMatch(`${basePath}/lorebook/edit/:id`);
  const matchEditEntries = useMatch(`${basePath}/lorebook/edit/:id/entries`);
  const matchDetail = useMatch(`${basePath}/lorebook/:id`);
  const { isAuthenticated } = useAuth();

  const resolveLorebookMetaPageId = (): PageId | null => {
    if (matchCreate) {
      return "lorebookCreate";
    }
    if (matchEdit || matchEditEntries) {
      return "lorebookEdit";
    }
    return null;
  };
  const lorebookMetaPageId = resolveLorebookMetaPageId();

  let pageContent: ReactNode;
  if (!isAuthenticated && matchCreate) {
    pageContent = <AnonymousMarketing datakey="lorebook" />;
  } else if (matchCreate) {
    pageContent = <LorebookCreate />;
  } else if ((matchEdit || matchEditEntries) && id) {
    pageContent = <LorebookEdit id={id} />;
  } else if (matchDetail && id) {
    pageContent = <LorebookDetail id={id} />;
  } else {
    pageContent = <NotFound />;
  }

  return (
    <>
      {lorebookMetaPageId ? <PageStaticMetaTags pageId={lorebookMetaPageId} data-testid="Lorebook-PageStaticMetaTags" /> : null}
      {pageContent}
    </>
  );
}
